import * as scroll from '../helpers/scroll'

const openNav = ($mainMenu, $header) => {
  $mainMenu.classList.add('--open')
  $header.classList.add('--dark')

  scroll.disabled()
}

const closeNav = ($mainMenu, $header) => {
  $mainMenu.classList.remove('--open')
  $header.classList.remove('--dark')

  scroll.enabled()
}

class hm {
  constructor() {
    this.dom = {
      'header': document.querySelector('header'),
      'mainMenu': document.querySelector('.main-menu'),
      'nav': document.querySelector('.main-menu nav.--mobile .nav-items'),
      'hmLbl': document.querySelector('.hamburger-menu').querySelector('label'),
      'hmInp': document.querySelector('.hamburger-menu').querySelector('input')
    }
  }
  main() {
    this.dom.hmInp.addEventListener('change', (e) => {
      if (e.target.checked) {
        openNav(this.dom.mainMenu, this.dom.header)

        return false
      }

      closeNav(this.dom.mainMenu, this.dom.header)
    })

    this.dom.hmLbl.addEventListener('click', (e) => {
      e.stopPropagation()
    })

    this.dom.nav.addEventListener('click', (e) => {
      e.stopPropagation()
    })

    document.addEventListener('click', (e) => {
      if (this.dom.mainMenu.classList.contains('--open')) {
        this.dom.hmInp.checked = false
        closeNav(this.dom.mainMenu, this.dom.header)
      }
    })

    this.dom.hmLbl.addEventListener('touchstart', (e) => {
      e.stopPropagation()
    })

    this.dom.nav.addEventListener('touchstart', (e) => {
      e.stopPropagation()
    })

    document.addEventListener('touchstart', (e) => {
      if (this.dom.mainMenu.classList.contains('--open')) {
        this.dom.hmInp.checked = false
        closeNav(this.dom.mainMenu, this.dom.header)
      }
    })
  }
}

export default hm
